module.exports = __webpack_public_path__ + "static/media/26UNRWA4.5b6b48d5.jpg";